"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IndexedDollarParameter_1 = require("./IndexedDollarParameter");
var LinearScale = (function () {
    function LinearScale() {
        this._minThreshold = null;
        this._maxThreshold = null;
    }
    LinearScale.prototype.initialise = function (minThreshold, maxthreshold, indexationBasis) {
        this._minThreshold = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._maxThreshold = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._minThreshold.initialise(minThreshold, indexationBasis);
        this._maxThreshold.initialise(maxthreshold, indexationBasis);
    };
    LinearScale.prototype.resetValues = function (minThreshold, maxthreshold) {
        this._minThreshold.resetValues(minThreshold);
        this._maxThreshold.resetValues(maxthreshold);
    };
    LinearScale.prototype.index = function (year) {
        this._minThreshold.index(year);
        this._maxThreshold.index(year);
    };
    LinearScale.prototype.getProportion = function (value) {
        if (value < this._minThreshold.value) {
            return 1;
        }
        else if (value > this._maxThreshold.value) {
            return 0;
        }
        else {
            return (this._maxThreshold.value - value) / (this._maxThreshold.value - this._minThreshold.value);
        }
    };
    Object.defineProperty(LinearScale.prototype, "minimumThreshold", {
        get: function () { return this._minThreshold.value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LinearScale.prototype, "maximumThreshold", {
        get: function () { return this._maxThreshold.value; },
        enumerable: true,
        configurable: true
    });
    return LinearScale;
}());
exports.LinearScale = LinearScale;
//# sourceMappingURL=LinearScale.js.map